import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import axios from "axios";
import * as React from "react";
import { useState } from "react";
import { Navigate, NavLink } from "react-router-dom";
import logo from "../../asset/images/signin.jpg";
import SimpleBackdrop from "../BackDrop";
import { Copyright } from "../Copyright";
const theme = createTheme({
  typography: {
    fontFamily: [
      "Assistant",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});
export default function CreateAnAdmin() {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  const [wrongCredentials, setWrongCredentials] = React.useState(false);
  const [home, setHome] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
    setOpen(true);
    const data = new FormData(event.currentTarget);
    console.log({
      email: data.get("email"),
      password: data.get("password"),
    });
    axios
      .post(`${process.env.React_APP_BACKEND_URL}/api/admin/register`, {
        email: data.get("email"),
        password: data.get("password"),
      })
      .then((data1) => {
        if (data1.status === 200) {
          console.log(data1);
          setOpen(false);
          setHome(true);
        } else {
          setWrongCredentials(true);
        }
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response.status);
        setWrongCredentials(true);
        setOpen(false);
        if (err.response.status === 401) setWrongCredentials(true);
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />

        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            fontFamily: "Assistant",
          }}
        >
          {home && <Navigate to="/admin/login"></Navigate>}
          <NavLink to="/home" sx={{ textDecoration: "none" }}>
            <img src={logo} style={{ objectFit: "fit-content" }} alt="פשוט למצוא בעל מקצוע לוגו" />
          </NavLink>
          <Typography
            component="h1"
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              fontWeight: "bold",
            }}
            variant="h5"
          >
            הירשם כמנהל
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1, fontFamily: "Assistant" }}
          >
            <TextField
              margin="normal"
              sx={{ fontFamily: "Assistant" }}
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              sx={{ fontFamily: "Assistant" }}
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={
                <Checkbox
                  value="remember"
                  color="primary"
                  sx={{ fontFamily: "Asisstant" }}
                />
              }
              label="Remember me"
            />
            {wrongCredentials && (
              <p style={{ color: "red", fontFamily: "Assistant" }}>
                This email does not exist in our server or we did not send you
                the invitation to become an admin
              </p>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, fontFamily: "Assistant" }}
            >
              Sign Up as Admin
            </Button>
            <Grid container>
              <Grid item>
                <NavLink to="/admin/login" variant="body2">
                  {"Have an admin account? Sign In"}
                </NavLink>
              </Grid>
            </Grid>
          </Box>
          {open && (
            <SimpleBackdrop
              open={open}
              setOpen={setOpen}
              handleClose={handleClose}
              handleToogle={handleToggle}
            />
          )}
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
